module.exports = __webpack_public_path__ + "img/video605.b923b74a.jpg";